import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { MainContext } from '@blaze-cms/nextjs-components';
import { TextSearch, Checkbox, SelectFilter, Range } from '../components';
import { CHECKBOX, SELECT, TEXT_SEARCH, RANGE, SEARCH_TERM } from '../constants';

const FiltersList = ({
  data,
  filters,
  hasUrl,
  entity,
  filterValues,
  updateFilterValues,
  shouldSearch
}) => {
  const { itemId } = useContext(MainContext);

  return filters.map(
    ({ type, label, propsToDisplay, elementTitle, unit, ...otherProps }, index) => {
      if (!propsToDisplay && !propsToDisplay.length) return null;
      const dynamicKey = [itemId, index].join('-');
      const isDataAvailable = !!data && Object.keys(data).length;
      const dataAggregations = isDataAvailable ? data : null;
      const areAggregationsAvailable = isDataAvailable && !!dataAggregations;

      switch (type) {
        case TEXT_SEARCH:
          return (
            <div
              key={dynamicKey}
              className="filter__section filter__section--search-refine filter__section--search">
              <TextSearch
                {...otherProps}
                label={label}
                elementTitle={elementTitle}
                searchValue={filterValues[SEARCH_TERM]}
                updateFilterValues={updateFilterValues}
                filterValues={filterValues}
              />
            </div>
          );

        case CHECKBOX:
          return (
            <div
              key={dynamicKey}
              className="filter__section filter__section--search-refine filter__section--checkboxes">
              <Checkbox
                {...otherProps}
                data={data}
                prop={propsToDisplay[0]}
                label={label}
                elementTitle={elementTitle}
                hasUrl={hasUrl}
                filterValues={filterValues}
                updateFilterValues={updateFilterValues}
                shouldSearch={shouldSearch}
              />
            </div>
          );

        case SELECT:
          return (
            <div
              key={dynamicKey}
              className="filter__section filter__section--search-refine filter__section--selects">
              <SelectFilter
                {...otherProps}
                data={data}
                prop={propsToDisplay[0]}
                label={label}
                elementTitle={elementTitle}
                hasUrl={hasUrl}
                filterValues={filterValues}
                updateFilterValues={updateFilterValues}
                shouldSearch={shouldSearch}
              />
            </div>
          );

        case RANGE:
          return (
            !!areAggregationsAvailable && (
              <div key={dynamicKey} className="range-slider__wrapper">
                <Range
                  {...otherProps}
                  dataAggregations={dataAggregations}
                  propsToDisplay={propsToDisplay}
                  label={label}
                  elementTitle={elementTitle}
                  unit={unit}
                  entity={entity}
                  filterValues={filterValues}
                  updateFilterValues={updateFilterValues}
                  shouldSearch={shouldSearch}
                />
              </div>
            )
          );
        default:
          return null;
      }
    }
  );
};

FiltersList.propTypes = {
  hasUrl: PropTypes.bool.isRequired,
  entity: PropTypes.string.isRequired,
  filterValues: PropTypes.object.isRequired,
  updateFilterValues: PropTypes.func.isRequired,
  data: PropTypes.object,
  filters: PropTypes.array,
  shouldSearch: PropTypes.bool
};

FiltersList.defaultProps = {
  shouldSearch: false,
  data: {},
  filters: []
};

export default FiltersList;
